<script lang="ts">
	//Svelte
	import { createEventDispatcher } from 'svelte';
	//Design System Components
	import { CardGrid, Container, Icon, Modal, SelectCard } from '@Shelly/shelly-design-system/index';
	//Helpers
	import {
		checkIsActionDisabled,
		dropdownSubmenuData,
		SHARED_HOME_ADD_ACTION_KEYS,
		type DrodpwonMenuSubmenuItemsTypes,
		type MenuListDataType,
	} from 'src/helpers/main_menu';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showAddActionsModal = false;

	const dispatchEvent = createEventDispatcher<{
		'click-action': DrodpwonMenuSubmenuItemsTypes;
	}>();

	const changeIconToLight = (icon: MenuListDataType['icon']) => {
		const iconName = icon?.split(' ')[1];
		return `fal ${iconName}`;
	};

	const addActionsItems = dropdownSubmenuData.map((data) => {
		const lightIcon = changeIconToLight(data.icon);

		return {
			...data,
			icon: lightIcon,
		};
	});

	/**
	 * Shared homes only allow dashboard-related add actions; everything else is
	 * managed by the home owner, so it is filtered out of the modal.
	 */
	$: isSharedHome = isActiveHomeShared($homes.list);
	$: primaryAddActionsItems = (() => {
		const items = addActionsItems.slice(0, addActionsItems.length - 1);
		return isSharedHome
			? items.filter((item) =>
					SHARED_HOME_ADD_ACTION_KEYS.includes(
						item.key as (typeof SHARED_HOME_ADD_ACTION_KEYS)[number],
					),
				)
			: items;
	})();
	$: addDeviceActionItem = addActionsItems[addActionsItems.length - 1];
	$: showAddDeviceActionItem = addDeviceActionItem?.key === 'devices' && !isSharedHome;

	const onClose = () => {
		showAddActionsModal = false;
	};

	const onSelectItemClick = (item: DrodpwonMenuSubmenuItemsTypes | MenuListDataType) => {
		dispatchEvent('click-action', item as DrodpwonMenuSubmenuItemsTypes);
		onClose();
	};
</script>

<Modal bind:showModal={showAddActionsModal} on:close={onClose} removeScrollPadding hideTitle>
	<Container slot="content" padding="scrollPaddings">
		<CardGrid md={250} noPaddingBottom gridGap="s">
			{#each primaryAddActionsItems as option}
				{@const isAddActionDisabled = checkIsActionDisabled(option)}
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					hideAction
					class="width-full"
					type="horizontal"
					icon={option.icon}
					title={$format(option.title, {
						default: option.defaultText,
					})}
					hideRightCustomAction={!option.rightIcon}
					on:click={() => {
						onSelectItemClick(option);
					}}
					disabled={isAddActionDisabled}
				>
					<Icon
						slot="customActionRight"
						icon={option.rightIcon && 'fa-solid fa-chevron-right'}
						size="s"
					/>
				</SelectCard>
			{/each}
		</CardGrid>
		{#if showAddDeviceActionItem}
			<hr class="mt-l mb-l" />
			<CardGrid md={250} noPaddingBottom>
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					hideAction
					class="width-full"
					type="horizontal"
					icon={addDeviceActionItem.icon}
					title={$format(addDeviceActionItem.title, {
						default: addDeviceActionItem.defaultText,
					})}
					hideRightCustomAction={!addDeviceActionItem.rightIcon}
					on:click={() => {
						onSelectItemClick(addDeviceActionItem);
					}}
				>
					<Icon
						slot="customActionRight"
						icon={addDeviceActionItem.rightIcon && 'fa-solid fa-chevron-right'}
						size="s"
					/>
				</SelectCard>
			</CardGrid>
		{/if}
	</Container>
</Modal>
